
<template>
  <div>
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <a-form-model
        size="small"
        layout="inline"
        :model="ajaxparams"
        @keyup.native.enter="$refs.myTable.search()"
      >
        <a-form-model-item label="员工名称">
          <a-input
            placeholder="请输入员工名称"
            v-model="ajaxparams.name_like"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button icon="search" @click="$refs.myTable.search()" type="primary"
            >搜索</a-button
          >
          <a-button @click="reset()" style="margin-left: 8px">重置</a-button>
        </a-form-model-item>
      </a-form-model>

      <div class="mt10">
        <a-button type="primary" @click="check">添加员工</a-button>
      </div>

      <MyTable
        class="mt10"
        :apiUrl="packingEmployee_index"
        :params="ajaxparams"
        ref="myTable"
        :columns="columns"
        :isSelection="false"
      >
        <a-space slot="button" slot-scope="item, row, index">
          <a-button size="small" type="primary" @click="check(row)"
            >编辑</a-button
          >
          <a-popconfirm
            title="确定删除该员工？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="onDel(row)"
          >
            <a-button size="small" type="danger">删除</a-button>
          </a-popconfirm>
        </a-space>

        <template slot="type" slot-scope="text">
          <a-tag :color="getTypeColor(text)">{{ getTypeText(text) }}</a-tag>
        </template>
      </MyTable>

      <a-modal
        :maskClosable="false"
        v-model="dialogVisible"
        :confirm-loading="submitLoading"
        title="员工信息"
        @ok="onSubmit"
        @cancel="handleCancel"
      >
        <a-form-model :rules="rules" ref="formModel" size="small" :model="form">
          <a-form-model-item label="员工名称" prop="name">
            <a-input placeholder="请输入员工名称" v-model="form.name" />
          </a-form-model-item>
          <a-form-model-item label="拼音">
            <a-input placeholder="请输入拼音" v-model="form.pinyin" />
          </a-form-model-item>
          <a-form-model-item label="类型" prop="type">
            <a-select
              style="width: 200px"
              allowClear
              v-model="form.type"
              placeholder="请选择类型"
            >
              <a-select-option :value="1">女工计件</a-select-option>
              <a-select-option :value="2">全自动线</a-select-option>
              <a-select-option :value="3">内袋线</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import {
  packingEmployee_index,
  packingEmployee_save,
  packingEmployee_del,
} from "@/api/quality";

export default {
  name: "QualityEmployees",
  components: { MyTable },
  data() {
    return {
      packingEmployee_index: packingEmployee_index,
      ajaxparams: {},
      columns: [
        {
          title: "操作",
          key: "operation",
          width: 160,
          fixed: "left",
          ellipsis: true,
          scopedSlots: { customRender: "button" },
        },
        { title: "ID", dataIndex: "id", key: "id", width: 80 },
        { title: "员工名称", dataIndex: "name", key: "name", width: 140 },
        { title: "拼音", dataIndex: "pinyin", key: "pinyin", width: 120 },
        {
          title: "类型",
          dataIndex: "type",
          key: "type",
          width: 120,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "创建时间",
          dataIndex: "create_at",
          key: "create_at",
          width: 180,
        },
        {
          title: "更新时间",
          dataIndex: "update_at",
          key: "update_at",
          width: 180,
        },
      ],
      dialogVisible: false,
      submitLoading: false,
      form: {},
      typeAction: "add",
      rules: {
        name: [{ required: true, message: "请输入员工名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
    };
  },
  methods: {
    reset() {
      this.ajaxparams = {};
      this.$refs.myTable.search();
    },
    check(row) {
      if (row && row.id) {
        this.form = {
          id: row.id,
          name: row.name,
          pinyin: row.pinyin,
          type: row.type,
        };
        this.typeAction = "edit";
      } else {
        this.form = { name: "", pinyin: "", type: undefined };
        this.typeAction = "add";
      }
      this.dialogVisible = true;
    },
    onSubmit() {
      this.$refs.formModel.validate(async (valid) => {
        if (!valid) return false;
        const payload = { ...this.form };
        if (typeof payload.type === "string")
          payload.type = Number(payload.type);
        this.submitLoading = true;
        packingEmployee_save(payload)
          .then(() => {
            this.$message.success("操作成功");
            setTimeout(() => {
              this.$refs.myTable.getList();
              this.submitLoading = false;
              this.dialogVisible = false;
            }, 800);
          })
          .catch(() => {
            this.submitLoading = false;
          });
      });
    },
    handleCancel() {
      this.submitLoading = false;
      this.dialogVisible = false;
    },
    onDel(row) {
      packingEmployee_del({ id: row.id }).then(() => {
        this.$message.success("删除成功");
        setTimeout(() => {
          this.$refs.myTable.getList();
        }, 500);
      });
    },
    getTypeText(type) {
      const typeMap = {
        1: "女工计件",
        2: "全自动线",
        3: "内袋线",
      };
      return typeMap[type] || "-";
    },
    getTypeColor(type) {
      const colorMap = {
        1: "blue",
        2: "green",
        3: "orange",
      };
      return colorMap[type] || "default";
    },
  },
};
</script>

<style scoped></style>
